import { useParams } from 'react-router';
import OrganizationContentStack from '@/components/organization-content-stack';
import { useActiveOrganizationStore } from '@/state/stores/use-organization-store';
import OrganizationTeamList from '@/components/organizations/organization-team-list';

export default function OrganizationTeamListPage() {
  const { organizationId } = useParams();
  const activeOrganization = useActiveOrganizationStore((s) => s.activeOrganization);

  if (!organizationId || !activeOrganization || organizationId !== activeOrganization.id) {
    return null;
  }

  return <OrganizationContentStack content={<OrganizationTeamList organizationId={organizationId} />} />;
}
